import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel, FieldDescription } from '@/components/ui/field';
import { Bell, Coins } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const FORM_LOW_BALANCE_ALERT_ID = 'form-low-balance-alert';

export default function FormLowBalanceAlert({ company, companyBalance, onSubmit }) {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [threshold, setThreshold] = useState('');

    useEffect(() => {
        setEmail(company?.settings?.low_balance_token_email ?? '');
        setThreshold(company?.settings?.low_balance_token_threshold ?? '');
    }, [company]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            email: email.trim() || null,
            threshold: threshold !== '' ? Number(threshold) : null,
        });
    };

    return (
        <form
            id={FORM_LOW_BALANCE_ALERT_ID}
            onSubmit={handleSubmit}
            className="flex-1 overflow-y-auto px-5 py-5 space-y-5"
        >
            {/* Info banner */}
            <div className="flex items-start gap-3 bg-primary/10 rounded-xl px-4 py-3">
                <Bell className="h-4 w-4 text-secondary mt-0.5 shrink-0" strokeWidth={1.5} />
                <p className="text-[13px] text-muted-foreground leading-relaxed">
                    {t('account:recevezUnEmailLorsqueVotreSoldeDeJetons')}
                </p>
            </div>

            {/* Email */}
            <Field>
                <FieldLabel>{t('account:adresseEmailDeNotification')}</FieldLabel>
                <Input
                    type="email"
                    placeholder="votre@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </Field>

            {/* Threshold */}
            <Field>
                <FieldLabel>{t('account:seuilDAlerteNombreDeJetonsRestants')}</FieldLabel>
                <Input
                    type="number"
                    min={0}
                    placeholder="50"
                    value={threshold}
                    onChange={(e) => setThreshold(e.target.value)}
                />
                {threshold !== '' && Number(threshold) >= 0 && (
                    <FieldDescription className="text-[11px]">
                        {t('account:vousSerezAlerteQuandVotreSoldePasseraSous')} {threshold} jetons.
                    </FieldDescription>
                )}
            </Field>

            {/* Current balance */}
            <div className="flex items-center gap-2 bg-secondary/10 border border-secondary/20 rounded-xl px-4 py-3">
                <span className="text-[13px] text-foreground">{t('account:soldeActuel')}</span>
                <span className="text-[13px] text-secondary font-semibold">{companyBalance ?? 0} jetons</span>
            </div>
        </form>
    );
}
